import React, { useMemo } from 'react';
import { useTheme } from '../../styles/ThemeProvider';

export const Sparkline = ({ data = [], width = 80, height = 24, color }) => {
  const { theme } = useTheme();
  const stroke = color || theme.color.accent;
  const path = useMemo(() => {
    if (!data.length) return '';
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const step = width / Math.max(data.length - 1, 1);
    return data
      .map((v, i) => `${i === 0 ? 'M' : 'L'}${(i * step).toFixed(1)},${(height - ((v - min) / range) * height).toFixed(1)}`)
      .join(' ');
  }, [data, width, height]);
  if (!data.length) return null;
  return (
    <svg width={width} height={height} style={{ overflow: 'visible' }}>
      <path d={path} fill="none" stroke={stroke} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
